import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EncContinuousFilterField } from '@mode-vegas/vegas';

@Component({
  selector: 'mode-numeric-range',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './numeric-range.component.html',
  styleUrls: ['./numeric-range.component.scss'],
})
export class NumericRangeComponent implements OnChanges {
  @Input() dataMin: number | undefined | null;
  @Input() dataMax: number | undefined | null;
  @Input() filter!: EncContinuousFilterField;
  @Input() isLoading = true;

  @Output() filterChange = new EventEmitter<EncContinuousFilterField>();
  @Output() isInvalid = new EventEmitter<boolean>();

  filterMin: number | null = null;
  filterMax: number | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filter !== undefined) {
      this.filterMin = this.filter.range.min;
      this.filterMax = this.filter.range.max;
    }
  }

  onMinChange(min: number) {
    this.filterMin = min;
    this.onInputChange();
  }

  onMaxChange(max: number) {
    this.filterMax = max;
    this.onInputChange();
  }

  onInputChange() {
    if (this.validate()) {
      this.filterChange.emit({
        ...this.filter,
        range: {
          min: this.filterMin as number,
          max: this.filterMax as number,
        },
      });
    }
  }

  onBlurInput() {
    this.validate();
  }

  validate() {
    // Validate that the min < max if set
    if (this.filterMin !== null && this.filterMax !== null && this.filterMin > this.filterMax) {
      this.isInvalid.emit(true);
      return false;
    }
    this.isInvalid.emit(false);
    return true;
  }
}
